import React from 'react';

class WaitMsg extends React.Component {

    constructor() {
        super();
        this.fechar = this.fechar.bind(this);
    }

    fechar() {
        this.props.fechar();
    }

    render() {
        return (
            <div id="dashboard-wait-msg">
                <p id="dashboard-wait-msg-fechar-btn" onClick={ this.fechar }>
                    Fechar
                </p>
                <p id="dashboard-wait-msg-txt">
                    { this.props.msg }
                </p>
            </div>
        );
    }

}

export default WaitMsg;

